export const COMPANY = 'made1ncamana';
export const COMPANY_NAME = 'Made in Camaná';
export const CONNECTION = Object.freeze({
  CKEY: 'lhc31', CBD: 'wIFM8uALxSdNo4GYhBuv+FYj3gMGMFGifQ9I3JpvpxM=',
  CCONTRASENIA: 'pPh3IAsYygssiAATzxFPPA==', CUSERCREA: 'wIFM8uALxSdNo4GYhBuv+Jt6QqQSU9olZcqab5fw4lw=',
  CLOCALHOST: 'e8qNu8mVA615JpoOO898BEB5Biyg3XSh21suAMe/LYg='
});
export function apiUrl(path) {
  const origin = import.meta.env?.VITE_API_ORIGIN || 'https://mc-4i4zykdg2m.bunny.run';
  return new URL(path.replace(/^\//, ''), origin.replace(/\/$/, '') + '/').href;
}
export function today() {
  const parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Lima', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
  const value = Object.fromEntries(parts.map(item => [item.type, item.value]));
  return `${value.year}-${value.month}-${value.day}`;
}
